import angular from 'angular';

import r2a from '@web/angularIntegration/r2a';
import ReactPremiumFeatureBanner from '@web/components/PremiumFeatureBanner.tsx';
import ExportButtonAngular from '@web/components/ExportButton/ExportButtonAngular.tsx';
import ChiliPiperBannerAngular from '@web/chiliPiper/ChiliPiperBannerAngular';

import markdownHintsComponent from './markdownHintsComponent';
import photoswipeComponent from './photoswipeComponent';
import attachments from './attachments';
import attachment from './attachment';
import actionsFooterComponent from './actionsFooterComponent';
import slingHeaderComponent from './slingHeaderComponent';
import spinnerComponent from './spinnerComponent';
import sortIconComponent from './sortIconComponent';
import buttonTabsComponent from './buttonTabsComponent';
import moneyDisplayComponent from './moneyDisplayComponent';
import manageAvailabilityComponent from './manageAvailabilityComponent';
import availabilitySetsComponent from './availabilitySetsComponent';
import customSelectComponent from './customSelectComponent';
import dateRangePickerComponent from './dateRangePickerComponent';
import dateRangeSelectorComponent from './dateRangeSelectorComponent';
import printButtonComponent from './printButtonComponent';
import exportButtonComponent from './exportButtonComponent';
import durationDisplayComponent from './durationDisplayComponent';
import premiumTrialEndModalHandlerComponent from './premiumTrialEndModalHandlerComponent';
import blocksNavigationComponent from './blocksNavigationComponent';
import employeeBlocksNavigationComponent from './employeeBlocksNavigationComponent';
import managerBlocksNavigationComponent from './managerBlocksNavigationComponent';
import previewBannerComponent from './previewBannerComponent';
import scrollspyComponent from './scrollspyComponent';
import shiftAppearanceComponent from './shiftAppearanceComponent';
import slingTourModalComponent from './slingTourModalComponent';
import askModalComponent from './askModalComponent';
import appearancePreviewComponent from './appearancePreviewComponent';
import timezoneDiscrepancyComponent from './timezoneDiscrepancyComponent';
import googleCalendarIssuesComponent from './googleCalendarIssuesComponent';
import browseGroupsButtonsComponent from './browseGroupsButtonsComponent';
import collapseToggleComponent from './collapseToggleComponent';
import radioGroupComponent from './radioGroupComponent';
import comments from './comments';
import displayAlerts from './displayAlertsComponent';
import whatsNew from './whatsNewComponent';
import bogusSwitcherComponent from './bogusSwitcherComponent';
import premiumPreviewRowComponent from './premiumPreviewRowComponent';
import otherPremiumFeaturesComponent from './otherPremiumFeaturesComponent';
import customerReviewsComponent from './customerReviewsComponent';
import purchasePremiumButtonComponent from './purchasePremiumButtonComponent';
import linkedTags from './linkedTags';
import linkedPositions from './linkedPositions';
import linkedLocations from './linkedLocations';
import linkedGroups from './linkedGroups';
import userEditableWages from './userEditableWagesComponent';
import premiumDiscoveryPopupComponent from './premiumDiscoveryPopupComponent';
import countryPicker from './countryPickerComponent';
import editableValueComponent from './editableValueComponent';
import selectGroupComponent from './selectGroupComponent';
import salesInlineEditComponent from './salesInlineEditComponent';
import unavailabilityPreviewComponent from './unavailabilityPreviewComponent';
import durationPickerComponent from './durationPickerComponent';
import foldableSearchComponent from './foldableSearchComponent';
import rectangleIconButtonComponent from './rectangleIconButtonComponent';
import selectBoxComponent from './selectBoxComponent';
import selectBoxLookupItemComponent from './selectBoxLookupItemComponent';
import selectBoxSelectionTagComponent from './selectBoxSelectionTagComponent';
import inputSkeletonPlaceholderComponent from './inputSkeletonPlaceholderComponent';
import emailSuggestionComponent from './emailSuggestionComponent';
import errorBannerComponent from './errorBannerComponent';
import languageSelectComponent from './languageSelectComponent';
import npsScoreComponent from './npsScoreComponent';
import psatScoreComponent from './psatScoreComponent';
import externalRateComponent from './externalRateComponent';
import afterSignupSurveyComponent from './afterSignupSurveyComponent';
import costsSaveBannerComponent from './costsSaveBannerComponent';
import getMobileAppPopupComponent from './getMobileAppPopupComponent';
import singleUnavailabilitySetComponent from './singleUnavailabilitySetComponent';
import membersToggleComponent from './membersToggle/membersToggleComponent';
import happinessSurveyComponent from './happinessSurveyComponent';
import chiliPiperBannerComponent from './chiliPiperBanner';
import notificationModalComponent from './notificationModalComponent';
import subscriptionPreferenceSurveyComponent from './subscriptionPreferenceSurveyComponent';

const componentsModule = angular.module('components.components', []);

componentsModule.component('markdownHints', markdownHintsComponent);
componentsModule.component('photoswipe', photoswipeComponent);
componentsModule.component('attachments', attachments);
componentsModule.component('attachment', attachment);
componentsModule.component('actionsFooter', actionsFooterComponent);
componentsModule.component('slingHeader', slingHeaderComponent);
componentsModule.component('spinner', spinnerComponent);
componentsModule.component('sortIcon', sortIconComponent);
componentsModule.component('buttonTabs', buttonTabsComponent);
componentsModule.component('moneyDisplay', moneyDisplayComponent);
componentsModule.component('manageAvailability', manageAvailabilityComponent);
componentsModule.component('availabilitySets', availabilitySetsComponent);
componentsModule.component('customSelect', customSelectComponent);
componentsModule.component('dateRangePicker', dateRangePickerComponent);
componentsModule.component('dateRangeSelector', dateRangeSelectorComponent);
componentsModule.component('printButton', printButtonComponent);
componentsModule.component('exportButton', exportButtonComponent);
componentsModule.component('rExportButton', r2a(ExportButtonAngular));
componentsModule.component('durationDisplay', durationDisplayComponent);
componentsModule.component('premiumTrialEndModalHandler', premiumTrialEndModalHandlerComponent);
componentsModule.component('blocksNavigation', blocksNavigationComponent);
componentsModule.component('employeeBlocksNavigation', employeeBlocksNavigationComponent);
componentsModule.component('managerBlocksNavigation', managerBlocksNavigationComponent);
componentsModule.component('previewBanner', previewBannerComponent);
componentsModule.component('scrollspy', scrollspyComponent);
componentsModule.component('shiftAppearance', shiftAppearanceComponent);
componentsModule.component('slingTourModal', slingTourModalComponent);
componentsModule.component('askModal', askModalComponent);
componentsModule.component('appearancePreview', appearancePreviewComponent);
componentsModule.component('timezoneDiscrepancy', timezoneDiscrepancyComponent);
componentsModule.component('googleCalendarIssues', googleCalendarIssuesComponent);
componentsModule.component('browseGroupsButtons', browseGroupsButtonsComponent);
componentsModule.component('radioGroup', radioGroupComponent);
componentsModule.component('comments', comments);
componentsModule.component('displayAlerts', displayAlerts);
componentsModule.component('whatsNew', whatsNew);
componentsModule.component('bogusSwitcher', bogusSwitcherComponent);
componentsModule.component('premiumPreviewRow', premiumPreviewRowComponent);
componentsModule.component('otherPremiumFeatures', otherPremiumFeaturesComponent);
componentsModule.component('customerReviews', customerReviewsComponent);
componentsModule.component('purchasePremiumButton', purchasePremiumButtonComponent);
componentsModule.component('premiumDiscoveryPopup', premiumDiscoveryPopupComponent);
componentsModule.component('linkedTags', linkedTags);
componentsModule.component('linkedPositions', linkedPositions);
componentsModule.component('linkedLocations', linkedLocations);
componentsModule.component('linkedGroups', linkedGroups);
componentsModule.component('userEditableWages', userEditableWages);
componentsModule.component('collapseToggle', collapseToggleComponent);
componentsModule.component('countryPicker', countryPicker);
componentsModule.component('editableValue', editableValueComponent);
componentsModule.component('selectGroup', selectGroupComponent);
componentsModule.component('salesInlineEdit', salesInlineEditComponent);
componentsModule.component('unavailabilityPreview', unavailabilityPreviewComponent);
componentsModule.component('durationPicker', durationPickerComponent);
componentsModule.component('foldableSearch', foldableSearchComponent);
componentsModule.component('rectangleIconButton', rectangleIconButtonComponent);
componentsModule.component('selectBox', selectBoxComponent);
componentsModule.component('selectBoxLookupItem', selectBoxLookupItemComponent);
componentsModule.component('selectBoxSelectionTag', selectBoxSelectionTagComponent);
componentsModule.component('inputSkeletonPlaceholder', inputSkeletonPlaceholderComponent);
componentsModule.component('emailSuggestion', emailSuggestionComponent);
componentsModule.component('errorBanner', errorBannerComponent);
componentsModule.component('languageSelect', languageSelectComponent);
componentsModule.component('npsScore', npsScoreComponent);
componentsModule.component('psatScore', psatScoreComponent);
componentsModule.component('externalRate', externalRateComponent);
componentsModule.component('notificationModal', notificationModalComponent);
componentsModule.component('afterSignupSurvey', afterSignupSurveyComponent);
componentsModule.component('costsSaveBanner', costsSaveBannerComponent);
componentsModule.component('getMobileAppPopup', getMobileAppPopupComponent);
componentsModule.component('singleUnavailabilitySet', singleUnavailabilitySetComponent);
componentsModule.component('membersToggle', membersToggleComponent);
componentsModule.component('rPremiumFeatureBanner', r2a(ReactPremiumFeatureBanner));
componentsModule.component('happinessSurvey', happinessSurveyComponent);
componentsModule.component('rChiliPiperBanner', r2a(ChiliPiperBannerAngular));
componentsModule.component('chiliPiperBanner', chiliPiperBannerComponent);
componentsModule.component('subscriptionPreferenceSurvey', subscriptionPreferenceSurveyComponent);

export default componentsModule.name;
